<script>
import { VTextFieldMasked } from 'v-text-field-masked'

import fetch from '@maxsystems/ui/api'
import { phone as validatePhone } from '@maxsystems/ui/vue/validation'

import { verifyAccess as verifyAccessMutation } from '../queries'
import VerifyAccess from './VerifyAccess'

export default {
  components: {
    VerifyAccess,
    VTextFieldMasked
  },
  props: {
    opportunityId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    accessToken: null,
    challenge: null,
    loading: false,
    errors: {},
    phone: null,
    showVerifyAccess: false
  }),
  methods: {
    createChallenge () {
      if (!this.validate() || this.loading) return
      this.loading = true

      return fetch(verifyAccessMutation, {
        opportunityId: this.opportunityId,
        phone: `+1${this.phone}`
      })
        .then(({ data: gql, errors }) => {
          if (!gql || !gql.verifyAccess || errors) {
            this.errors.other = errors?.[0]?.message || 'Error creating Challenge'
            return
          }

          this.challenge = gql.verifyAccess.challenge
          this.showVerifyAccess = true
        })
        .catch((error) => {
          this.errors.other = error?.message || 'Error creating Challenge'
        })
        .finally(() => {
          this.loading = false
        })
    },

    validate () {
      this.errors = {}

      if (!this.phone || validatePhone(this.phone) !== true) {
        this.errors.phone = 'Invalid phone number'
      }

      return Object.keys(this.errors).length === 0
    },

    setAccessToken (token) {
      this.accessToken = token
      this.$store.commit('opportunity/setAccessToken', token)
      this.$emit('success', token)
    }
  }
}
</script>

<template>
  <div class="opportunity__otp">
    <VCard
      v-if="!showVerifyAccess"
      class="v-card--otp"
      :loading="loading"
      :disabled="loading"
    >
      <VCardTitle class="text-h6 justify-center pt-8 pb-6">
        Enter your phone number to continue
      </VCardTitle>
      <VCardText>
        <VTextFieldMasked
          v-model="phone"
          class="opportunity__otp__phone mx-4"
          :error="Boolean(errors.phone)"
          :error-messages="errors.phone"
          label="Phone"
          mask="phone"
          type="tel"
          outlined
          @keyup.enter="createChallenge"
          @input="errors.phone = null"
        />
      </VCardText>
      <VCardSubtitle
        v-if="errors.other"
        class="error--text"
      >
        {{ errors.other }}
      </VCardSubtitle>
      <VCardActions class="justify-center">
        <VBtn
          text
          @click="createChallenge"
        >
          Continue
        </VBtn>
      </VCardActions>
    </VCard>
    <VerifyAccess
      v-if="showVerifyAccess && !accessToken"
      :challenge="challenge"
      :opportunity-id="opportunityId"
      @update:accessToken="setAccessToken"
      @resend="createChallenge"
    />
  </div>
</template>

<style lang="scss">
.opportunity__otp {
  .v-card__text {
    padding-bottom: 0;
  }

  .v-messages__message {
    margin-bottom: 0;
  }

  .opportunity__otp__phone:not(.error--text) {
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
